import React from 'react';

export const IsraelFlagIcon = (props) => {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 3L24 3L24 20L0 20L0 3Z" fill="white" />
      <path d="M0 4.59375L24 4.59375V7.25L0 7.25L0 4.59375Z" fill="#0038B8" />
      <path d="M0 15.75L24 15.75V18.4063L0 18.4062L0 15.75Z" fill="#0038B8" />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M11.9998 7.82031L13.0907 9.66062L15.2725 9.66062L14.1816 11.5009L15.2725 13.3412H13.0907L11.9998 15.1815L10.9089 13.3412H8.72705L9.81796 11.5009L8.72705 9.66062H10.9089L11.9998 7.82031ZM10.5625 10.245H9.76628L10.1644 10.9165L10.5625 10.245ZM10.5108 11.5009L11.2553 10.245H12.7443L13.4888 11.5009L12.7443 12.7568H11.2553L10.5108 11.5009ZM10.1644 12.0853L9.76628 12.7568H10.5625L10.1644 12.0853ZM11.6017 13.3412L11.9998 14.0128L12.3979 13.3412H11.6017ZM13.4371 12.7568H14.2333L13.8352 12.0853L13.4371 12.7568ZM13.8352 10.9165L14.2333 10.245H13.4371L13.8352 10.9165ZM12.3979 9.66062H11.6017L11.9998 8.98906L12.3979 9.66062Z" 
        fill="#0038B8" 
      />
    </svg>
  );
};


export const USFlagIcon = (props) => {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M24 6L0 6L0 19L24 19L24 6Z" fill="#B22234" />
      <path d="M0 7.5L24 7.5L0 7.5ZM24 9.5L0 9.5L24 9.5ZM0 11.5L24 11.5L0 11.5ZM24 13.5L0 13.5L24 13.5ZM0 15.5L24 15.5L0 15.5ZM24 17.5L0 17.5L24 17.5Z" fill="black" />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M24 8L0 8L0 7L24 7V8ZM0 9L24 9V10L0 10L0 9ZM24 12L0 12L0 11L24 11V12ZM0 13L24 13V14L0 14L0 13ZM24 16L0 16L0 15L24 15V16ZM0 17L24 17V18L0 18L0 17Z" 
        fill="white" 
      />
      <path d="M9.6 6L0 6L0 13L9.6 13L9.6 6Z" fill="#3C3B6E" />
      <path d="M0.799817 6.30078L1.02827 7.02439L0.430176 6.57717H1.16946L0.571366 7.02439L0.799817 6.30078Z" fill="white" />
      <path d="M0.799817 7.69922L1.02827 8.42283L0.430176 7.97561H1.16946L0.571366 8.42283L0.799817 7.69922Z" fill="white" />
      <path d="M0.799817 9.10156L1.02827 9.82517L0.430176 9.37796H1.16946L0.571366 9.82517L0.799817 9.10156Z" fill="white" />
      <path d="M0.799817 10.5L1.02827 11.2236L0.430176 10.7764H1.16946L0.571366 11.2236L0.799817 10.5Z" fill="white" />
      <path d="M0.799817 11.9023L1.02827 12.626L0.430176 12.1787H1.16946L0.571366 12.626L0.799817 11.9023Z" fill="white" />
      <path d="M1.59962 7L1.82807 7.72361L1.22998 7.27639H1.96926L1.37117 7.72361L1.59962 7Z" fill="white" />
      <path d="M1.59962 8.39844L1.82807 9.12204L1.22998 8.67483H1.96926L1.37117 9.12204L1.59962 8.39844Z" fill="white" />
      <path d="M1.59962 9.80078L1.82807 10.5244L1.22998 10.0772H1.96926L1.37117 10.5244L1.59962 9.80078Z" fill="white" />
      <path d="M1.59962 11.1992L1.82807 11.9228L1.22998 11.4756H1.96926L1.37117 11.9228L1.59962 11.1992Z" fill="white" />
      <path d="M2.39991 6.30078L2.62837 7.02439L2.03027 6.57717H2.76956L2.17146 7.02439L2.39991 6.30078Z" fill="white" />
      <path d="M2.39991 7.69922L2.62837 8.42283L2.03027 7.97561H2.76956L2.17146 8.42283L2.39991 7.69922Z" fill="white" />
      <path d="M2.39991 9.10156L2.62837 9.82517L2.03027 9.37796H2.76956L2.17146 9.82517L2.39991 9.10156Z" fill="white" />
      <path d="M2.39991 10.5L2.62837 11.2236L2.03027 10.7764H2.76956L2.17146 11.2236L2.39991 10.5Z" fill="white" />
      <path d="M2.39991 11.9023L2.62837 12.626L2.03027 12.1787H2.76956L2.17146 12.626L2.39991 11.9023Z" fill="white" />
      <path d="M3.19972 7L3.42817 7.72361L2.83008 7.27639H3.56936L2.97127 7.72361L3.19972 7Z" fill="white" />
      <path d="M3.19972 8.39844L3.42817 9.12204L2.83008 8.67483H3.56936L2.97127 9.12204L3.19972 8.39844Z" fill="white" />
      <path d="M3.19972 9.80078L3.42817 10.5244L2.83008 10.0772H3.56936L2.97127 10.5244L3.19972 9.80078Z" fill="white" />
      <path d="M3.19972 11.1992L3.42817 11.9228L2.83008 11.4756H3.56936L2.97127 11.9228L3.19972 11.1992Z" fill="white" />
      <path d="M4.00001 6.30078L4.22846 7.02439L3.63037 6.57717H4.36965L3.77156 7.02439L4.00001 6.30078Z" fill="white" />
      <path d="M4.00001 7.69922L4.22846 8.42283L3.63037 7.97561H4.36965L3.77156 8.42283L4.00001 7.69922Z" fill="white" />
      <path d="M4.00001 9.10156L4.22846 9.82517L3.63037 9.37796H4.36965L3.77156 9.82517L4.00001 9.10156Z" fill="white" />
      <path d="M4.00001 10.5L4.22846 11.2236L3.63037 10.7764H4.36965L3.77156 11.2236L4.00001 10.5Z" fill="white" />
      <path d="M4.00001 11.9023L4.22846 12.626L3.63037 12.1787H4.36965L3.77156 12.626L4.00001 11.9023Z" fill="white" />
      <path d="M4.79982 7L5.02827 7.72361L4.43018 7.27639H5.16946L4.57137 7.72361L4.79982 7Z" fill="white" />
      <path d="M4.79982 8.39844L5.02827 9.12204L4.43018 8.67483H5.16946L4.57137 9.12204L4.79982 8.39844Z" fill="white" />
      <path d="M4.79982 9.80078L5.02827 10.5244L4.43018 10.0772H5.16946L4.57137 10.5244L4.79982 9.80078Z" fill="white" />
      <path d="M4.79982 11.1992L5.02827 11.9228L4.43018 11.4756H5.16946L4.57137 11.9228L4.79982 11.1992Z" fill="white" />
      <path d="M5.60011 6.30078L5.82856 7.02439L5.23047 6.57717H5.96975L5.37166 7.02439L5.60011 6.30078Z" fill="white" />
      <path d="M5.60011 7.69922L5.82856 8.42283L5.23047 7.97561H5.96975L5.37166 8.42283L5.60011 7.69922Z" fill="white" />
      <path d="M5.60011 9.10156L5.82856 9.82517L5.23047 9.37796H5.96975L5.37166 9.82517L5.60011 9.10156Z" fill="white" />
      <path d="M5.60011 10.5L5.82856 11.2236L5.23047 10.7764H5.96975L5.37166 11.2236L5.60011 10.5Z" fill="white" />
      <path d="M5.60011 11.9023L5.82856 12.626L5.23047 12.1787H5.96975L5.37166 12.626L5.60011 11.9023Z" fill="white" />
      <path d="M6.39991 7L6.62837 7.72361L6.03027 7.27639H6.76956L6.17146 7.72361L6.39991 7Z" fill="white" />
      <path d="M6.39991 8.39844L6.62837 9.12204L6.03027 8.67483H6.76956L6.17146 9.12204L6.39991 8.39844Z" fill="white" />
      <path d="M6.39991 9.80078L6.62837 10.5244L6.03027 10.0772H6.76956L6.17146 10.5244L6.39991 9.80078Z" fill="white" />
      <path d="M6.39991 11.1992L6.62837 11.9228L6.03027 11.4756H6.76956L6.17146 11.9228L6.39991 11.1992Z" fill="white" />
      <path d="M7.19972 6.30078L7.42817 7.02439L6.83008 6.57717H7.56936L6.97127 7.02439L7.19972 6.30078Z" fill="white" />
      <path d="M7.19972 7.69922L7.42817 8.42283L6.83008 7.97561H7.56936L6.97127 8.42283L7.19972 7.69922Z" fill="white" />
      <path d="M7.19972 9.10156L7.42817 9.82517L6.83008 9.37796H7.56936L6.97127 9.82517L7.19972 9.10156Z" fill="white" />
      <path d="M7.19972 10.5L7.42817 11.2236L6.83008 10.7764H7.56936L6.97127 11.2236L7.19972 10.5Z" fill="white" />
      <path d="M7.19972 11.9023L7.42817 12.626L6.83008 12.1787H7.56936L6.97127 12.626L7.19972 11.9023Z" fill="white" />
      <path d="M7.99952 7L8.22798 7.72361L7.62988 7.27639H8.36917L7.77107 7.72361L7.99952 7Z" fill="white" />
      <path d="M7.99952 8.39844L8.22798 9.12204L7.62988 8.67483H8.36917L7.77107 9.12204L7.99952 8.39844Z" fill="white" />
      <path d="M7.99952 9.80078L8.22798 10.5244L7.62988 10.0772H8.36917L7.77107 10.5244L7.99952 9.80078Z" fill="white" />
      <path d="M7.99952 11.1992L8.22798 11.9228L7.62988 11.4756H8.36917L7.77107 11.9228L7.99952 11.1992Z" fill="white" />
      <path d="M8.79982 6.30078L9.02827 7.02439L8.43018 6.57717H9.16946L8.57137 7.02439L8.79982 6.30078Z" fill="white" />
      <path d="M8.79982 7.69922L9.02827 8.42283L8.43018 7.97561H9.16946L8.57137 8.42283L8.79982 7.69922Z" fill="white" />
      <path d="M8.79982 9.10156L9.02827 9.82517L8.43018 9.37796H9.16946L8.57137 9.82517L8.79982 9.10156Z" fill="white" />
      <path d="M8.79982 10.5L9.02827 11.2236L8.43018 10.7764H9.16946L8.57137 11.2236L8.79982 10.5Z" fill="white" />
      <path d="M8.79982 11.9023L9.02827 12.626L8.43018 12.1787H9.16946L8.57137 12.626L8.79982 11.9023Z" fill="white" />
    </svg>
  );
};

export const GlobeIcon = (props) => {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path 
        d="M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z" 
        stroke="#231D1F" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M3.6001 9H20.4001" 
        stroke="#231D1F" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M3.6001 15H20.4001" 
        stroke="#231D1F" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M11.4999 3C9.81525 5.69961 8.92212 8.81787 8.92212 12C8.92212 15.1821 9.81525 18.3004 11.4999 21" 
        stroke="#231D1F" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M12.5 3C14.1847 5.69961 15.0778 8.81787 15.0778 12C15.0778 15.1821 14.1847 18.3004 12.5 21" 
        stroke="#231D1F" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};